/**
 * Lower-right launcher — opens the Navigator, drawn in the workspace's voice.
 */

import type { AssistantMode } from '../../lib/harry/assistantMode';
import { AssistantAvatar } from './AssistantAvatar';
import { useTheme } from '../../contexts/ThemeContext';

export function HarryFloatingLauncher({
  mode,
  onOpen,
}: {
  mode: AssistantMode;
  onOpen: () => void;
}) {
  const { isDark } = useTheme();
  const label = 'Open the Navigator';

  return (
    <button
      type="button"
      onClick={onOpen}
      className={`group fixed bottom-6 right-6 z-40 inline-flex items-center rounded-full border p-1.5 shadow-lg transition-all hover:shadow-xl ${
        isDark
          ? 'border-[var(--rule-bright)] bg-[var(--surface)] hover:border-[rgba(61,75,111,0.45)]'
          : 'border-[var(--rule)] bg-[var(--bg-raised)]'
      }`}
      title={label}
      aria-label={label}
    >
      <AssistantAvatar mode={mode} size={32} pulse />
    </button>
  );
}
